import { Autocomplete, Chip, TextField } from "@mui/material";
import React, { useEffect, useState } from "react";
import { locationOptions } from "../../constants";
import useDebounce from "../../base/useDebounce";

const LocationSearchAutoComplete = (props) => {

    const {
        data,
        value,
        onChange,
        multiSelect = false,
        disabled = false,
        size = 'small',
        placeholder = "",
        inputProps,
        InputProps
    } = props;

    const [inputValue, setInputValue] = useState('');
    const [options, setOptions] = useState([]);

    const debounceSearchTerm = useDebounce(inputValue, 400);

    const onSelectValue = (event, newValue) => {
        console.log(newValue)
        if (multiSelect) {
            onChange(newValue?.map((a) => typeof a === 'string' ? a : a.description) ?? []);
        } else {
            onChange(newValue?.description);
        }
    }

    const onChangeInput = (event, newInputValue) => {
        setInputValue(newInputValue);
    }

    useEffect(() => {
        if (!debounceSearchTerm) {
            setOptions([]);
        } else {
            const newOptions = data?.filter((item) => `${item?.cityName}`.toLowerCase()?.includes(debounceSearchTerm?.toLowerCase()))
                ?.slice(0, 15)
                ?.map((item) => ({ description: `${item?.cityName}` })) || [];
            setOptions(newOptions);
        }
    }, [debounceSearchTerm])

    return (
        <Autocomplete
            {...props}
            getOptionLabel={(option) =>
                typeof option === 'string' ? option : option.description
            }
            filterOptions={(x) => x}
            renderTags={(value, getTagProps) =>
                value.map((option, index) => (
                    <Chip variant="outlined" label={typeof option === 'string' ? option : option.description} {...getTagProps({ index })} />
                ))
            }
            limitTags={2}
            multiple={multiSelect}
            disabled={disabled}
            // autoFocus={autoFocus}
            size={size}
            options={debounceSearchTerm ? options : locationOptions}
            autoComplete
            includeInputInList
            filterSelectedOptions
            value={value}
            noOptionsText="No locations"
            onChange={onSelectValue}
            // inputValue={inputValue}
            onInputChange={onChangeInput}
            renderInput={(params) => (
                <TextField label={props?.label} {...params} placeholder={placeholder} size={size} 
                    InputProps={{ ...params.InputProps, ...InputProps }}
                    inputProps={{ ...params.inputProps, ...inputProps }}
                />
            )}
        
        />
    )
}

export default LocationSearchAutoComplete;